import { Auth } from "@wac-ui-dashboard/wac_component_library";
import { useOutletContext } from "react-router-dom";
import useCaptureEmail from "./useCaptureEmail";

const CaptureEmail = () => {
  const { emailRef } = useOutletContext();

  const {
    email,
    errors,
    emailCaptureStatus,
    handleSubmit,
    handleChange,
    handleBlur,
    handleLoginClick,
  } = useCaptureEmail(emailRef);
  
  return (
    <Auth
      title={"Forgot Password"}
      buttonText={"Submit"}
      handleClick={handleSubmit}
      actionText={"Back to login"}
      handleActionClick={handleLoginClick}
      loading={emailCaptureStatus === "pending"}
    >
      <div className="input-wrap pro-mb-5">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Enter your email address
        </label>
        <input
          value={email}
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          className={`pro-input lg ${errors && "error"}`}
        />
        {errors && <span className="error-text">{errors}</span>}
      </div>
    </Auth>
  );
};

export default CaptureEmail;
